import { datadogLogs } from '@datadog/browser-logs'

const datadogLogger = datadogLogs.createLogger('authLogger', {
  level: 'error',
})

/**
 * Auth-specific logger that provides consistent logging for authentication operations
 * with proper prefixing and context
 */
const logger = {
  /**
   * Log debug information for auth operations
   * @param {string} message - The message to log
   * @param {...any} args - Additional arguments to log
   */
  debug: (message, ...args) => {
    datadogLogger.debug(`auth: ${message}`, ...args)
  },

  /**
   * Log informational messages for auth operations
   * @param {string} message - The message to log
   * @param {...any} args - Additional arguments to log
   */
  info: (message, ...args) => {
    datadogLogger.log(`auth: ${message}`, ...args)
  },

  /**
   * Log warnings for auth operations
   * @param {string} message - The message to log
   * @param {...any} args - Additional arguments to log
   */
  warn: (message, ...args) => {
    datadogLogger.warn(`auth: ${message}`, ...args)
  },

  /**
   * Log errors for auth operations
   * @param {string} message - The message to log
   * @param {...any} args - Additional arguments to log
   */
  error: (message, ...args) => {
    datadogLogger.error(`auth: ${message}`, ...args)
  },
}

export default logger
